import '../../Pages/Expert/OrdreMission.scss';
import './FactureStyle.scss';

import CloseIcon from '@mui/icons-material/Close';
//import { print } from 'react-html2pdf';
//import { Preview, print } from 'react-html2pdf';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { AppBar, Button, IconButton, ScopedCssBaseline, Toolbar } from '@mui/material';
import Dialog from '@mui/material/Dialog';
//import { PDFExport } from '@progress/kendo-react-pdf';
import jsPDF from 'jspdf';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// import  from '../../../src/Assets/LOGOHTH.png';
import logoDataDelegates from '../../../src/Assets/LOGOHTH.png';
import { extractCityName, extractCountryName } from '../../data/Countries';
import {getFournisseurInfo, MonthsString} from '../../data/Interfaces';
//import useAuth from '../../hooks/useAuth';
import { useNumberFormatting } from '../../hooks/useNumberFormatting';
import useWindowSize from '../../hooks/useWindowSize';
import { bdc, ordreMissionStyles } from '../../Styles/componentStyles';
import {minutesDifferenceToDecimalHours } from '../../Utils/getCalendarMonthMatrix';
import {searchLabelInEnumByValue, TestExistValue } from '../../Utils/utils';
import { calculateIsMontantOrCoeffOfAstreinte, calculateMontantTotalOfOneAstreinte, calculateMontantTotalOfOneHno } from '../../Utils/utilsCraX';
import { buttonStyles } from '../docsAdministrative/JsObjectStyles';
import { Transition } from '../shared/ReusableSmallComponents';
const FactureG = ({ facture, handleClose, open, role }) => {

    FactureG.propTypes = {
        facture: PropTypes.any,
        open: PropTypes.any,
        role: PropTypes.any,
        handleClose: PropTypes.func,
    };
    //const { auth } = useAuth();
    const { formatNumber, addEuro4Decimal } = useNumberFormatting();
    const [adresseFacturation, setAdresseFacturation] = useState({});
    //PS: reda faut ajouter delaiPaiement chez l'expert
    const [delaiPaiement, setDelaiPaiement] = useState('');
    const [infoFournisseur,setInfoFournisseur]=useState({});
    const { device } = useWindowSize();
    const [totalTtc,setTotalTtc] = useState('');
    const [totalHt,setTotalHt] = useState('');
    const [totalTva,setTotalTva ]= useState('');
    const [tva,setTva] = useState('');
    const { i18n } = useTranslation();
    const montantTotalHt = (facture) => {
        const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
        if (role === 'client') {
            return (isCraOrCraX === 'craId' ? facture?.craId?.montantTotalClient || facture?.craId?.tjClient * facture?.craId?.nbrDays : facture?.craXId?.montantTotalClient);
        }
        if (role === 'expert') {
            return (isCraOrCraX === 'craId' ? facture?.craId?.montantTotal || facture?.craId?.tj * facture?.craId?.nbrDays : facture?.craXId?.montantTotal);
        }
    };

    const tauxJournalier = (facture) => {
        const isCraOrCraX = facture?.craId?.nbrDays ? 'craId' : 'craXId';
        if (role === 'client') {
            return isCraOrCraX === 'craId' ? facture?.craId?.tjClient : facture?.craXId?.tjClient;
        }
        if (role === 'expert') {
            return isCraOrCraX === 'craId' ? facture?.craId?.tj : facture?.craXId?.tj;
        }
    };

    const tvaApplique = (facture) => {
        if(role=='client'){
            return (facture?.tvaClient && facture?.tvaClient != undefined) ? facture?.tvaClient : 0;
        }
        if(role=='expert')
        {
            return (facture?.tva && facture?.tva != undefined) ? facture?.tva : 0;
        }
    };

    useEffect(() => {
        const factureArray = facture?.factures?.length > 0 ? facture?.factures : facture?.facturesX;
        const isCraOrCraX = facture?.factures?.length > 0 ? 'craId' : 'craXId';
        const factureItem = factureArray[0];
        const temp = {};
        const tempInfoFournisseur={};
        setDelaiPaiement(factureItem?.delaiPaiement);
        setTotalTva(facture?.totalClient?.toFixed(2) - facture?.totalHtClient?.toFixed(2));
        setTva(tvaApplique(facture));
        temp.nomEntreprise = facture?.companyDataId?.profileEntreprise?.nom;

        if (TestExistValue(facture?.companyDataId?.donneeFacturation?.adresseFacturation)) {
            temp.adresse = TestExistValue(facture?.companyDataId?.donneeFacturation?.adresseFacturation);
            temp.ville = facture?.companyDataId?.donneeFacturation?.codePostal + ' ' +extractCityName(facture?.companyDataId?.donneeFacturation?.localisation) +' '+ extractCountryName(facture?.companyDataId?.donneeFacturation?.localisation);
        } else {
            temp.adresse = facture?.companyDataId?.profileEntreprise?.address;
            temp.ville = facture?.companyDataId?.profileEntreprise?.codePostal + ' ' + extractCityName(facture?.companyDataId?.profileEntreprise?.localisation)+ ' '+ extractCountryName(facture?.companyDataId?.profileEntreprise?.localisation);
        }
        temp.noTVA=facture?.companyDataId?.profileEntreprise?.noTVA;
        setAdresseFacturation(temp);
        setTotalTtc(facture?.totalClient);
        setTotalHt(facture?.totalHtClient);
        tempInfoFournisseur.societe=getFournisseurInfo(factureItem?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData?.email).societe;
        tempInfoFournisseur.adresse=getFournisseurInfo(factureItem?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData?.email).adresse;
        tempInfoFournisseur.ville=getFournisseurInfo(factureItem?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData?.email).ville;
        tempInfoFournisseur.noTVA=getFournisseurInfo(factureItem?.[isCraOrCraX]?.bdcId?.backOfficeId?.persoData?.email).notva;
        setInfoFournisseur(tempInfoFournisseur);
    }, [facture]);

    // const totalTVA=(facture)=>{
    //     return ((montantTotalHt(facture) * tvaApplique(facture))/100).toFixed(2);
    // };

    const scroll = 'paper';
    const handleGeneratePdf = () => {
        const doc = new jsPDF({
            format: 'a2',
            unit: 'px',
        });

        // Get the total number of pages
        const totalPages = doc.internal.getNumberOfPages();

        // Loop through each page and add text to the footer
        for (let i = 1; i <= totalPages; i++) {
        // Go to the specific page
            doc.setPage(i);

            // Add text to the footer
            doc.text('Conformément à l\'article L441-6 du code de commerce, en cas de retard de paiement, une indemnité de trois fois le taux de l\'intérêt légal en vigueur ainsi', 50, doc.internal.pageSize.getHeight() - 40, { align: 'left' });
            doc.text('qu\'une indemnité forfaitaire pour frais de recouvrement de 40€, seront exigibles.', 50, doc.internal.pageSize.getHeight() - 20, { align: 'left' });
        }

        const fileName=facture?.refFactureClient+'_FACTURE_DD_To_'+adresseFacturation?.nomEntreprise+'_'+facture?.refCmdClient;

        doc.html(document.getElementById('reportTemplateRef'),
            {
                async callback(doc) {
                    await doc.save(fileName);
                },
                margin: [40, 48, 50, 40],
                autoPaging: 'text',
            },
        );
    };
    console.log('factureG',facture);
    return (
        <Dialog
            fullScreen
            open={open}
            TransitionComponent={Transition}
            onClose={handleClose}
            scroll={scroll}
            PaperProps={{
                style: {
                    background: '#F5F6FA',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>

            <div style={{ display: 'flex', flexDirection: device == 'desktop' ? 'row' : 'column', justifyContent: 'space-around', background: '#F5F6FA', paddingTop: '90px', paddingLeft: '24px', paddingBottom: '24px', paddingRight: device == 'desktop' ? '0px' : '24px', gap: device == 'desktop' ? '0px' : '16px' }}>
                {device != 'desktop' &&
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '30px', width: '100%' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                            <h5 className='TitleFrame1OM'>
                                {i18n.t('Self-bill Facture')}
                            </h5>
                            <IconButton
                                onClick={handleGeneratePdf}
                                variant="outlined"
                                style={{ ...buttonStyles(), ...{ color: '#214DCE', border: '1px solid #214DCE', order: 2, margin: '0' } }}

                            >
                                <FileDownloadOutlinedIcon style={{ color: '#214DCE', margin: '0px' }} />
                            </IconButton>
                        </div>
                        <div style={{ borderBottom: 'solid 2px #C3C9F1', margin: '0px' }}></div>
                    </div>
                }
                <div className='frame1bdc'>
                    <div
                        id='reportTemplateRef'
                        style={ordreMissionStyles.page}
                    >
                        <ScopedCssBaseline>
                            {facture &&
                                <>
                                    <div style={bdc.FileFrame0Bdc}>
                                        {role == 'expert' ?

                                            <div style={bdc.FileFrame1Bdc}>
                                                <h4 style={bdc.FileFrame2Bdc}>{i18n.t('Self-bill Facture')}</h4>
                                                <div style={bdc.FileFrame31321Bdc}>
                                                    <span style={bdc.FileFrame4Bdc}>
                                                        {i18n.t('Facture N°')}: {facture?.refFactureClient}
                                                    </span>
                                                    {/* <span style={bdc.FileFrame5Bdc}>
                                                        Date de facture: {formatDateJJMMYYYY(moment(getLastWorkingDayOfMonth(
                                                            dayjs(new Date(facture?.[facture?.isCraOrCraX]?.year, facture?.[facture?.isCraOrCraX]?.month-1)).locale('fr').format('YYYY'),
                                                            dayjs(new Date(facture?.[facture?.isCraOrCraX]?.year, facture?.[facture?.isCraOrCraX]?.month-1)).locale('fr').format('MM'),
                                                            (facture?.[facture?.isCraOrCraX]?.missionId?.companyDataId?.profileEntreprise?.localisation?.split('/')?.pop()||'fr'))))}
                                                    </span> */}
                                                </div>
                                            </div>
                                            :
                                            <div
                                                style={ordreMissionStyles.logo}
                                            >
                                                <img src={logoDataDelegates} />
                                            </div>
                                        }

                                        <div style={bdc.FileFrame1Bdc}>
                                            {role == 'expert' ?
                                                <div
                                                    style={ordreMissionStyles.logo}
                                                >
                                                    <img src={logoDataDelegates} />
                                                </div>
                                                :
                                                <h4 style={bdc.FileFrame2Bdc}> {i18n.t('Self-bill Facture')}</h4>
                                            }
                                            {role == 'client' &&
                                            <div style={bdc.FileFrame3Bdc}>
                                                <span style={bdc.FileFrame4Bdc}>
                                                    {i18n.t('Facture N°')}: {facture?.refFactureClient}
                                                </span>
                                                <span style={bdc.FileFrame5Bdc}>
                                                    {i18n.t('Date de facture')}: {facture?.dateFacturation}
                                                </span>
                                            </div>
                                            }

                                        </div>
                                    </div>
                                    <div style={bdc.FileFrame6Bdc}>
                                        <div style={bdc.FileFrame7Bdc}>
                                            <h4 style={bdc.FileFrame8Bdc}><b>
                                                {i18n.t('Fournisseur')}
                                            </b></h4>
                                            <div style={bdc.FileFrame9Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{infoFournisseur.societe}</p>
                                                <p style={bdc.FileFrame11Bdc}>{infoFournisseur.adresse}</p>
                                                <p style={bdc.FileFrame11Bdc}>{infoFournisseur.ville}</p>
                                                <br/>
                                                <div style={bdc.FileFrame10Bdc}>
                                                    <p style={bdc.FileFrame18Bdc}>{i18n.t('N° du TVA')}:</p><p style={bdc.FileFrame11Bdc}> &nbsp;&nbsp;{infoFournisseur.noTVA}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div style={bdc.FileFrame7Bdc}>
                                            <h4 style={bdc.FileFrame8Bdc}>
                                                <b>
                                                    {i18n.t('Adresse de facturation')}
                                                </b>
                                            </h4>
                                            <div style={bdc.FileFrame9Bdc}>
                                                <p style={bdc.FileFrame18Bdc}>{adresseFacturation?.nomEntreprise}</p>
                                                <p style={bdc.FileFrame11Bdc}>{adresseFacturation?.adresse}</p>
                                                <p style={bdc.FileFrame11Bdc}>{adresseFacturation?.ville}</p>
                                                <br/>

                                                <div style={bdc.FileFrame10Bdc}>
                                                    <p style={bdc.FileFrame18Bdc}>{i18n.t('N° du TVA')}:</p><p style={bdc.FileFrame11Bdc}>&nbsp;&nbsp;{adresseFacturation?.noTVA}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <br/> <br/> <br/>
                                    <div style={bdc.FileFrame13Bdc}>
                                        {role == 'client' &&
                                        <>
                                            <h4 style={bdc.FileFrame8Bdc}><b>
                                                {i18n.t('Réf. Commande Client')}: {facture?.refCmdClient}
                                            </b>
                                            </h4>
                                        </>
                                        }
                                    </div>
                                    <div style={bdc.FileFrame13Bdc}>
                                        <div style={bdc.FileFrame17Bdc}>
                                            <div style={bdc.FileFrame9Bdc}>
                                                <table style={{ border: '1px solid', width: '780px' }}>
                                                    <tr style={{ border: '1px solid', height: '40px', background: '#d5dce5' }}>
                                                        <th style={{ border: '1px solid', width: '300px', padding: '10px' }}>{i18n.t('Description')}</th>
                                                        <th style={{ border: '1px solid',width: '120px' , textAlign: 'center', padding: '10px' }}>{i18n.t('Quantité')}</th>
                                                        <th style={{ border: '1px solid',width: '180px' , textAlign: 'center', padding: '10px' }}>{i18n.t('Prix unitaire (HT)')}</th>
                                                        <th style={{ border: '1px solid',width: '180px' , textAlign: 'center', padding: '10px' }}>{i18n.t('Total (HT)')}</th>
                                                        {/* <th style={{ border: '1px solid', textAlign: 'center', padding: '10px' }}>{i18n.t('TVA appliquée')}</th>
                                                        <th style={{ border: '1px solid', textAlign: 'center', padding: '10px' }}>{i18n.t('Total TVA')}</th> */}
                                                    </tr>
                                                    {Array.isArray(facture?.factures) && facture?.factures.map((normalFacture, i) => (
                                                        <tr
                                                            style={{ border: '1px' }}
                                                            key={i}
                                                        >
                                                            <td style={{ border: '1px solid', padding: '10px', fontFamily: 'Lato' }}><b> {normalFacture?.craId?.missionId?.titre} </b> {i18n.t(searchLabelInEnumByValue(MonthsString, normalFacture?.craId?.month))+ '-' + normalFacture?.craId?.year} {(role == 'client' && normalFacture?.refIntClient) && <><br />{i18n.t('Réf. Int.')}: {normalFacture?.refIntClient}</>}</td>
                                                            <td style={{ border: '1px solid', textAlign: 'center' }}> {montantTotalHt(normalFacture) > 0 ? formatNumber(normalFacture?.craId?.nbrDays) : formatNumber(-1 * normalFacture?.craId?.nbrDays)}</td>
                                                            <td style={{ border: '1px solid', textAlign: 'center' }}> {formatNumber(tauxJournalier(normalFacture))}</td>
                                                            <td style={{ border: '1px solid', textAlign: 'center' }}>{formatNumber(montantTotalHt(normalFacture))}</td>
                                                            {/*<td style={{ border: '1px solid', textAlign: 'center' }}>{normalFacture?.totalHT}</td>*/}
                                                            {/* <td style={{ border: '1px solid', textAlign: 'center' }}>{addEuro4Decimal(tvaApplique(normalFacture), '%')}</td>
                                                            <td style={{ border: '1px solid', textAlign: 'center' }}>{formatNumber(totalTVA(normalFacture))}</td> */}
                                                            {/*<td style={{border: '1px solid',textAlign:'center'}}>
                                                                {role=='expert' ? facture?.BDCs?.tj
                                                                    : facture?.BDCs?.tjClient }</td>*/}
                                                        </tr>
                                                    ))
                                                    }

                                                    {Array.isArray(facture?.facturesX) &&facture?.facturesX.map((factureX, j) => (
                                                        <React.Fragment key={j}>
                                                            {
                                                                Array.isArray(factureX?.craXId?.astreintes) && factureX?.craXId?.astreintes.map((astreinte, i) => (
                                                                    <tr
                                                                        style={{ border: '1px' }}
                                                                        key={i}
                                                                    >
                                                                        {i == 0 ?
                                                                            <td
                                                                                className='FTdTabFacture'
                                                                                style={{
                                                                                    borderBottom: i == factureX?.craXId?.astreintes?.length - 1 ? '1px solid' : 'none',
                                                                                }}
                                                                            >
                                                                                <span className='titleOFTdFacture'> {i18n.t('Astreintes')} </span>{i18n.t(searchLabelInEnumByValue(MonthsString, factureX?.craXId?.month))+ '-' + factureX?.craXId?.year}{factureX?.refIntClient && <><br /> Réf. Int.: {factureX?.refIntClient}</>} <br /> {'   - ' + astreinte?.type}
                                                                            </td>
                                                                            :
                                                                            <td
                                                                                className='FTdTabFacture'
                                                                                style={{
                                                                                    borderBottom: i == factureX?.craXId?.astreintes?.length - 1 ? '1px solid' : 'none',
                                                                                }}
                                                                            >
                                                                                {'   - ' + astreinte?.type}
                                                                            </td>
                                                                        }
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.astreintes?.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        > {
                                                                                calculateMontantTotalOfOneAstreinte(astreinte,factureX?.craXId?.rules?.isMontant,role,factureX?.craXId?.tj,factureX?.craXId?.tjClient) > 0
                                                                                    ?
                                                                                    formatNumber(astreinte?.nbrAstreintes)
                                                                                    :
                                                                                    formatNumber(-1 * astreinte?.nbrAstreintes)

                                                                            }</td>
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.astreintes?.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >
                                                                            {formatNumber((calculateIsMontantOrCoeffOfAstreinte(astreinte?.montantUnit,factureX?.craXId?.rules?.isMontant==true ? true :false,role,factureX?.craXId?.tj,factureX?.craXId?.tjClient)))}
                                                                        </td>
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.astreintes?.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >{
                                                                                formatNumber(calculateMontantTotalOfOneAstreinte(astreinte,factureX?.craXId?.rules?.isMontant,role,factureX?.craXId?.tj,factureX?.craXId?.tjClient)?.toFixed(2))
                                                                            }</td>
                                                                        {/* <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.astreintes.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >
                                                                            {addEuro4Decimal(tvaApplique(factureX), '%')}
                                                                        </td>
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.astreintes.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >{
                                                                                formatNumber((calculateMontantTotalOfOneAstreinte(astreinte,factureX?.craXId?.rules?.isMontant,role,factureX?.craXId?.tj,factureX?.craXId?.tjClient) * tvaApplique(factureX) / 100).toFixed(2))
                                                                            }
                                                                        </td> */}
                                                                        {/*<td style={{border: '1px solid',textAlign:'center'}}>
                                                                            {role=='expert' ? facture?.BDCs?.tj
                                                                                : facture?.BDCs?.tjClient }</td>*/}
                                                                    </tr>
                                                                ))
                                                            }

                                                            {
                                                                Array.isArray(factureX?.craXId?.hnos) && factureX?.craXId?.hnos.map((hno, i) => (
                                                                    <tr
                                                                        style={{ border: '1px' }}
                                                                        key={i}
                                                                    >
                                                                        {i == 0 ?
                                                                            <td
                                                                                className='FTdTabFacture'
                                                                                style={{
                                                                                    borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                                }}
                                                                            >
                                                                                <span className='titleOFTdFacture'>{i18n.t('HNO')} </span>{i18n.t(searchLabelInEnumByValue(MonthsString, factureX?.craXId?.month))+ '-' + factureX?.craXId?.year}  {factureX?.refIntClient && <><br /> Réf. Int.: {factureX?.refIntClient}</>}<br /> {'   - ' + hno?.type}
                                                                            </td>
                                                                            :
                                                                            <td
                                                                                className='FTdTabFacture'
                                                                                style={{
                                                                                    borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                                }}
                                                                            >
                                                                                {'   - ' + hno?.type}
                                                                            </td>
                                                                        }
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >{
                                                                                (
                                                                                    Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin)) > 0
                                                                                        ?
                                                                                        formatNumber(Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin))?.toFixed(2))
                                                                                        :
                                                                                        formatNumber(-1 * Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin))?.toFixed(2))
                                                                                )
                                                                            }
                                                                        </td>
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >{
                                                                                formatNumber(
                                                                                    Math.abs(
                                                                                        calculateMontantTotalOfOneHno({ hno, tj: factureX?.craXId?.tj, role, tjClient: factureX?.craXId?.tjClient,nbrHrHno:factureX?.craXId?.rules?.nbrHrsHNOs })
                                                                                /
                                                                                Number(minutesDifferenceToDecimalHours(hno?.heureDebut, hno?.heureFin))
                                                                                    )?.toFixed(2)
                                                                                )
                                                                            }</td>
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >{
                                                                                formatNumber(calculateMontantTotalOfOneHno({ hno, tj: factureX?.craXId?.tj, role, tjClient: factureX?.craXId?.tjClient,nbrHrHno:factureX?.craXId?.rules?.nbrHrsHNOs })?.toFixed(2))
                                                                            }</td>
                                                                        {/* <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >
                                                                            {addEuro4Decimal(tvaApplique(factureX), '%')}
                                                                        </td>
                                                                        <td
                                                                            className='OTdTabFacture'
                                                                            style={{
                                                                                borderBottom: i == factureX?.craXId?.hnos.length - 1 ? '1px solid' : 'none',
                                                                            }}
                                                                        >{
                                                                                formatNumber((calculateMontantTotalOfOneHno({ hno, tj: factureX?.craXId?.tj, role, tjClient: factureX?.craXId?.tjClient, nbrHrHno:factureX?.craXId?.rules?.nbrHrsHNOs }) * tvaApplique(factureX) / 100).toFixed(2))
                                                                            }</td> */}
                                                                        {/*<td style={{border: '1px solid',textAlign:'center'}}>
                                                                            {role=='expert' ? facture?.BDCs?.tj
                                                                                : facture?.BDCs?.tjClient }</td>*/}
                                                                    </tr>
                                                                ))
                                                            }
                                                            {
                                                                Array.isArray(factureX?.craXId?.notesFrais) && factureX?.craXId?.notesFrais.map((note, i) => (
                                                                    <tr
                                                                        //style={{border:'1px'}}
                                                                        key={i}
                                                                    >
                                                                        {i == 0 ?
                                                                            <td className='FTdTabFacture'>
                                                                                <span className='titleOFTdFacture'> {i18n.t('Notes de frais')} </span> {i18n.t(searchLabelInEnumByValue(MonthsString, factureX?.craXId?.month))+ '-' + factureX?.craXId?.year} {factureX?.refIntClient && <><br /> Réf. Int.: {factureX?.refIntClient}</>} <br />{'   - ' + note?.type}
                                                                            </td>
                                                                            :
                                                                            <td className='FTdTabFacture'>
                                                                                {'   - ' + note?.type}
                                                                            </td>
                                                                        }
                                                                        <td className='OTdTabFacture'>{note?.montant > 0 ? formatNumber(1) : formatNumber(-1)}</td>
                                                                        <td className='OTdTabFacture'> {formatNumber(note?.montant?.toFixed(2))}</td>
                                                                        <td className='OTdTabFacture'>{formatNumber(note?.montant?.toFixed(2))}</td>
                                                                        {/* <td className='OTdTabFacture'>{addEuro4Decimal(tvaApplique(factureX), '%')}</td>
                                                                        <td className='OTdTabFacture'>{formatNumber((note?.montant * tvaApplique(factureX) / 100).toFixed(2))}</td> */}
                                                                        {/*<td style={{border: '1px solid',textAlign:'center'}}>
                                                                            {role=='expert' ? facture?.BDCs?.tj
                                                                                : facture?.BDCs?.tjClient }</td>*/}
                                                                    </tr>
                                                                ))
                                                            }
                                                        </React.Fragment>
                                                    ))
                                                    }
                                                </table>
                                            </div>
                                            <div style={bdc.FileFrame14Bdc}>
                                                <table style={{ border: '1px solid', width: '360px' }}>
                                                    <tr style={{ border: '1px solid', height: '33px' }}>
                                                        <th style={{ border: '1px solid', width: '180px', paddingLeft: '10px' }}>{i18n.t('Montant Total € ( HT )')} </th>
                                                        <th style={{ border: '1px solid', paddingRight: '10px',textAlign:'center' }}>
                                                            {addEuro4Decimal(totalHt, '')}
                                                        </th>
                                                    </tr>
                                                    <tr style={{ border: '1px solid', height: '33px' }}>
                                                        <th style={{ border: '1px solid', width: '180px', paddingLeft: '10px' }}>{i18n.t('Total TVA €')+ ' ( '+ tva + ' % )'} </th>
                                                        <th style={{ border: '1px solid', paddingRight: '10px',textAlign:'center' }}>
                                                            {addEuro4Decimal(totalTva, '')}
                                                        </th>
                                                    </tr>
                                                    <tr style={{ border: '1px solid', height: '33px' }}>
                                                        <th style={{ border: '1px solid', width: '180px', paddingLeft: '10px' }}>{i18n.t('Montant Total € ( TTC )')} </th>
                                                        <th style={{ border: '1px solid', paddingRight: '10px',textAlign:'center' }}>
                                                            {addEuro4Decimal(totalTtc, '')}
                                                        </th>
                                                    </tr>
                                                </table>
                                            </div>
                                            {/* <div style={bdc.FileFrame14Bdc}>
                                                <table style={{ border: '1px solid', width: '370px' }}>
                                                    <tr style={{ border: '1px solid', height: '33px' }}>
                                                        <th style={{ border: '1px solid', width: '233px', paddingLeft: '10px' }}>{i18n.t('Montant Total à payer TTC')} </th>
                                                        <th style={{ border: '1px solid', paddingLeft: '10px' }}>
                                                            {addEuro4Decimal(totalTtc, 'EUR')}
                                                        </th>
                                                    </tr>
                                                </table>
                                            </div> */}
                                        </div>
                                    </div>
                                    <br /><br /><br />
                                    <div style={bdc.FileFrame15Bdc}>
                                        <h4 style={bdc.FileFrame8Bdc}><b>{i18n.t('Conditions et mode de paiement')}:</b></h4>
                                        <p style={bdc.FileFrame11Bdc}>
                                            {i18n.t('Le règlement s\'effectuera par virement dans un délai de ')} {delaiPaiement} {i18n.t(' jours à partir de la date de facturation.')}<br />
                                        </p>
                                        <br /><br />
                                        {role == 'client' &&
                                        // <div style={bdc.FileFrame16Bdc}>
                                        <>
                                            <h4 style={bdc.FileFrame8Bdc}><b>
                                                {i18n.t('Coordonnées bancaires du fournisseur')}
                                            </b></h4>
                                            <div style={bdc.FileFrame9Bdc}>
                                                <div style={bdc.FileFrame10Bdc}>
                                                    <span style={bdc.FileFrame18818Bdc}><b>{i18n.t('Banque')} :</b></span><p style={bdc.FileFrame11Bdc}> &nbsp;Crédit industriel et commercial</p>
                                                </div>
                                                {/* <div style={bdc.FileFrame10Bdc}>
                                                    <p style={bdc.FileFrame18Bdc}>Code Swift : </p><p style={bdc.FileFrame11Bdc}>  &nbsp;{cordonneesBancaires?.code}</p>
                                                </div> */}
                                                <div style={bdc.FileFrame10Bdc}>
                                                    <span style={bdc.FileFrame18818Bdc}><b>{i18n.t('IBAN')} : </b></span><p style={bdc.FileFrame11Bdc}> &nbsp;FR76 3006 6106 9400 0202 3510 109</p>
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>
                                </>
                            }
                        </ScopedCssBaseline>
                    </div>
                </div>
                <div className='frame0bdc'>
                    <Button
                        className='TelechargerMissionOM'
                        variant="text"
                        style={{ ...buttonStyles(), ...{ color: '#272D3C', background: '#E7EAF9', width: '100%' } }}
                        startIcon={<FileDownloadOutlinedIcon style={{ color: '#272D3C' }} />}
                        onClick={handleGeneratePdf}
                    >
                        {i18n.t('Télécharger le document')}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default FactureG;
